import { useEffect } from "react";

export function useHorizontalScroll() {
  useEffect(() => {
    function onWheel(e) {
      if (!e.shiftKey) return;

      const target = getScrollableParent(e.target, "x");
      if (!target) return;

      e.preventDefault();
      target.scrollBy({ left: e.deltaY, behavior: "auto" });
    }

    let isDragging = false;
    let startX = 0;
    let scrollEl = null;
    let startScrollLeft = 0;

    function onMouseDown(e) {
      if (e.button !== 1) return; 

      const target = getScrollableParent(e.target, "x");
      if (!target) return;

      e.preventDefault(); 

      isDragging = true;
      startX = e.clientX;
      scrollEl = target;
      startScrollLeft = target.scrollLeft;

      document.body.style.cursor = "grabbing";
    }

    function onMouseMove(e) {
      if (!isDragging || !scrollEl) return;
      const dx = e.clientX - startX;
      scrollEl.scrollLeft = startScrollLeft - dx;
    }

    function onMouseUp(e) {
      if (e.button !== 1 && isDragging === false) return;
      isDragging = false;
      scrollEl = null;
      document.body.style.cursor = "";
    }

    window.addEventListener("wheel", onWheel, { passive: false });
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    window.addEventListener("mouseleave", onMouseUp);

    return () => {
      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("mouseleave", onMouseUp);
    };
  }, []);
}

function getScrollableParent(el, axis) {
  let node = el;
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const overflow =
      axis === "x"
        ? style.overflowX
        : style.overflowY;

    const isScrollable =
      overflow === "auto" || overflow === "scroll" || overflow === "overlay";

    const hasScroll =
      axis === "x"
        ? node.scrollWidth > node.clientWidth
        : node.scrollHeight > node.clientHeight;

    if (isScrollable && hasScroll) return node;
    node = node.parentElement;
  }

  return axis === "x" && document.documentElement.scrollWidth > window.innerWidth
    ? document.documentElement
    : null;
}
